<template>
  <div class="fix-width" v-if="!success">
    <h1>{{ __('Ändra betalningsinfo') }}</h1>

    <payment
      :next="() => (this.success = true)"
    >
      <div class="fix-width text-small margin-bottom-x3">
        {{
          __(
            'Välj betalningsalternativ ovan för att ändra från ditt nuvarande betalningssätt.'
          )
        }}
      </div>
    </payment>
  </div>
  <div v-else class="success">
    <h1>{{ __('Lyckades!') }}</h1>
    <p class="margin-bottom-x2">{{ __('Din betalningsinformation har uppdaterats') }}.</p>
    <button class="button" @click="() => this.$router.push('/')">
      {{ __('Tillbaka') }}
    </button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      success: false,
    }
  },
  components: {
    Payment: () => import('@/components/Payment.vue'),
  },
}
</script>
